import { j as e } from "./jsx-runtime-944c88e2.js";
import { Box as t, Text as n, Flex as r, Image as Y, Button as Z } from "@chakra-ui/react";
import "@chakra-ui/icons";
import "react";
import "./useAccount-2367dbfe.js";
import "./myasurion-shared.mixpanel.es.js";
import "./features-325864e1.js";
import { T as i } from "./eMyAsurionProvider-0702cfa3.js";
import "@tanstack/react-query";
import "./providers-fe718bdb.js";
import "react-router-dom";
import "./cleave-react-node-c4a374e5.js";
import "./lodash-9598aa3c.js";
import "@react-oauth/google";
import "./domains-8f7837df.js";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "@emotion/react";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
import "@emotion/styled";
const Ge = ({
  title: d,
  deviceName: v,
  image: z,
  requestedServiceLBL: j,
  requestedServiceVal: I,
  requestedTypeLBL: h,
  requestedTypeVal: F,
  imeiLBL: a,
  imeiVal: M,
  deliveryAddrsLBL: p,
  deliveryAddrsVal: N,
  deliveryDateTimeLBL: m,
  deliveryDateTimeVal: E,
  returnAddrsLBL: b,
  returnAddrsVal: _,
  returnDateTimeLBL: g,
  returnDateTimeVal: q,
  feeLBL: f,
  feeVal: H,
  paymentMethodLBL: D,
  paymentMethodVal: V,
  btnSubmitLBL: y,
  linkCancel: B,
  proxyAuthorisedDeliveryLBL: u,
  proxyAuthorisedDeliveryVal: J,
  proxyContactNumberDeliveryLBL: w,
  proxyContactNumberDeliveryVal: O,
  proxyIDLBL: K,
  proxyIDVal: P,
  paymentLabel: C,
  discountLBL: W,
  discountVal: Q,
  subtotalLBL: R,
  subtotalVal: U,
  totalLBL: o,
  totalVal: A,
  isDelivery: L,
  onClickSubmit: G,
  onClickCancel: ee,
  children: te,
  nightDeliveryFeesLBL: x,
  nightDeliveryFeesVal: $,
  dataTransferFeesLBL: c,
  dataTransferFeesVal: S,
  iswarranty: l,
  enableReviewBtn: k,
  alternativeContactNumber: T,
  ...X
}) => {
  const s = "ReviewSubmission";
  return console.log(k, "enableReviewButton shared"), /* @__PURE__ */ e.jsxs(t, { children: [
    /* @__PURE__ */ e.jsxs(
      t,
      {
        ...X,
        p: 4,
        alignItems: "center",
        w: { base: "full", lg: "60%" },
        margin: { base: "0", lg: "auto" },
        pb: { base: "0", lg: "140px" },
        children: [
          /* @__PURE__ */ e.jsx(t, { p: 2, children: d && /* @__PURE__ */ e.jsx(n, { fontSize: { base: "2xl", lg: "3xl" }, children: /* @__PURE__ */ e.jsx(i, { text: d, translationKey: `${s}/title` }) }) }),
          /* @__PURE__ */ e.jsx(t, { borderWidth: { base: "1px", lg: "0" }, borderRadius: "lg", borderColor: "#A5AAAF", children: /* @__PURE__ */ e.jsxs(
            r,
            {
              direction: { base: "column", lg: "row" },
              justifyContent: {
                base: "start",
                lg: l ? "center" : "space-between"
              },
              children: [
                /* @__PURE__ */ e.jsxs(
                  t,
                  {
                    w: { base: "full", lg: l ? "70%" : "45%" },
                    borderWidth: { base: "0", lg: "1px" },
                    borderRadius: "lg",
                    borderColor: "#A5AAAF",
                    children: [
                      /* @__PURE__ */ e.jsxs(
                        t,
                        {
                          backgroundColor: "#F0F0F5",
                          width: "100%",
                          p: 4,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          borderTopRadius: "lg",
                          children: [
                            /* @__PURE__ */ e.jsx(t, { fontSize: 20, mr: 4, children: v }),
                            /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(Y, { src: z, alt: "" }) })
                          ]
                        }
                      ),
                      /* @__PURE__ */ e.jsxs(t, { padding: { base: "10px", lg: "10px 30px" }, children: [
                        j && /* @__PURE__ */ e.jsx(t, { fontWeight: 700, mt: 2, children: /* @__PURE__ */ e.jsx(
                          i,
                          {
                            text: j,
                            translationKey: "Global/RequestedService"
                          }
                        ) }),
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { children: I }) }),
                        a && /* @__PURE__ */ e.jsx(t, { mt: 2, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                          i,
                          {
                            text: a,
                            translationKey: `${s}/imeiLBL`
                          }
                        ) }),
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { children: M }) }),
                        h && /* @__PURE__ */ e.jsx(t, { mt: 2, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                          i,
                          {
                            text: h,
                            translationKey: "Global/RequestType"
                          }
                        ) }),
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { children: F }) }),
                        T && /* @__PURE__ */ e.jsx(t, { mt: 2, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                          i,
                          {
                            text: "Alternate Contact Number",
                            translationKey: "Global/AlternativeContactNumber"
                          }
                        ) }),
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { children: T }) }),
                        p && /* @__PURE__ */ e.jsx(t, { mt: 2, fontWeight: 700, children: p }),
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { children: N }) }),
                        m && /* @__PURE__ */ e.jsx(t, { mt: 2, fontWeight: 700, children: m }),
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { children: E }) }),
                        b && /* @__PURE__ */ e.jsx(t, { mt: 2, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                          i,
                          {
                            text: b,
                            translationKey: "Global/ReturnAddress"
                          }
                        ) }),
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { children: _ }) }),
                        g && /* @__PURE__ */ e.jsx(t, { mt: 2, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                          i,
                          {
                            text: g,
                            translationKey: "Global/ReturnDateTime"
                          }
                        ) }),
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { children: q }) }),
                        u && /* @__PURE__ */ e.jsx(t, { mt: 2, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                          i,
                          {
                            text: u,
                            translationKey: `${s}/proxyAuthorisedDeliveryLBL`
                          }
                        ) }),
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { children: J }) }),
                        w && /* @__PURE__ */ e.jsx(t, { mt: 2, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                          i,
                          {
                            text: w,
                            translationKey: `${s}/proxyContactNumberDeliveryLBL`
                          }
                        ) }),
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { children: O }) }),
                        K && /* @__PURE__ */ e.jsx(t, { mt: 2, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                          i,
                          {
                            text: K,
                            translationKey: `${s}/proxyIDLBL`
                          }
                        ) }),
                        /* @__PURE__ */ e.jsx(t, { children: /* @__PURE__ */ e.jsx(n, { children: P }) })
                      ] })
                    ]
                  }
                ),
                !l && /* @__PURE__ */ e.jsxs(t, { px: { base: 4, lg: 0 }, w: { base: "full", lg: "45%" }, children: [
                  /* @__PURE__ */ e.jsx("hr", {}),
                  C && /* @__PURE__ */ e.jsx(n, { my: 2, fontSize: 18, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                    i,
                    {
                      text: C,
                      translationKey: `${s}/paymentLabel`
                    }
                  ) }),
                  /* @__PURE__ */ e.jsxs(r, { direction: "row", justifyContent: "space-between", children: [
                    f && /* @__PURE__ */ e.jsx(n, { m: 2, children: f }),
                    /* @__PURE__ */ e.jsx(n, { m: 2, children: H })
                  ] }),
                  $ && x && /* @__PURE__ */ e.jsxs(r, { direction: "row", justifyContent: "space-between", children: [
                    x && /* @__PURE__ */ e.jsx(n, { m: 2, children: /* @__PURE__ */ e.jsx(
                      i,
                      {
                        text: x,
                        translationKey: `${s}/nightDeliveryFeesLBL`
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(n, { m: 2, children: $ })
                  ] }),
                  S && c && /* @__PURE__ */ e.jsxs(r, { direction: "row", justifyContent: "space-between", children: [
                    c && /* @__PURE__ */ e.jsx(n, { m: 2, children: /* @__PURE__ */ e.jsx(
                      i,
                      {
                        text: c,
                        translationKey: `${s}/dataTransferFeesLBL`
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(n, { m: 2, children: S })
                  ] }),
                  /* @__PURE__ */ e.jsx(
                    "hr",
                    {
                      style: {
                        border: "none",
                        borderTop: "2px dotted #adaaaa"
                      }
                    }
                  ),
                  /* @__PURE__ */ e.jsxs(r, { direction: "row", justifyContent: "space-between", children: [
                    W && /* @__PURE__ */ e.jsx(n, { m: 2, children: /* @__PURE__ */ e.jsx(
                      i,
                      {
                        text: W,
                        translationKey: `${s}/discountLBL`
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(n, { m: 2, children: Q })
                  ] }),
                  /* @__PURE__ */ e.jsxs(r, { direction: "row", justifyContent: "space-between", children: [
                    R && /* @__PURE__ */ e.jsx(n, { m: 2, children: /* @__PURE__ */ e.jsx(
                      i,
                      {
                        text: R,
                        translationKey: "Global/Subtotal"
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(n, { m: 2, children: U })
                  ] }),
                  /* @__PURE__ */ e.jsxs(r, { direction: "row", justifyContent: "space-between", children: [
                    o && /* @__PURE__ */ e.jsx(n, { m: 2, fontWeight: 700, children: /* @__PURE__ */ e.jsx(
                      i,
                      {
                        text: o,
                        translationKey: "Global/Total"
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(n, { m: 2, fontWeight: 700, children: A })
                  ] })
                ] })
              ]
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs(
      t,
      {
        position: { base: "relative", lg: "fixed" },
        bottom: "0",
        w: "full",
        mt: "36px",
        pb: "10px",
        bgColor: { base: "", lg: "#faf9f5" },
        children: [
          /* @__PURE__ */ e.jsx(t, { display: { base: "none", lg: "block" }, children: /* @__PURE__ */ e.jsx(
            "hr",
            {
              style: {
                border: "none",
                borderTop: "2px solid #adaaaa"
              }
            }
          ) }),
          /* @__PURE__ */ e.jsxs(
            r,
            {
              direction: { base: "column", lg: "row-reverse" },
              align: "center",
              py: "10px",
              justifyContent: { base: "start", lg: l ? "center" : "space-between" },
              children: [
                /* @__PURE__ */ e.jsx(t, {}),
                /* @__PURE__ */ e.jsx(r, { direction: { base: "column", lg: "row-reverse" }, align: "center", children: /* @__PURE__ */ e.jsx(
                  Z,
                  {
                    w: { base: "300px", lg: "200px" },
                    color: "white",
                    colorScheme: "primary",
                    _hover: { bg: "primary", color: "white", outline: "none" },
                    onClick: () => k ? G && G() : void 0,
                    children: y && /* @__PURE__ */ e.jsx(i, { text: y, translationKey: "Global/Submit" })
                  }
                ) }),
                !l && /* @__PURE__ */ e.jsxs(t, { display: { base: "none", lg: "block" }, w: "20%", children: [
                  o && /* @__PURE__ */ e.jsx(n, { children: /* @__PURE__ */ e.jsx(i, { text: o, translationKey: "Global/Total" }) }),
                  /* @__PURE__ */ e.jsx(n, { fontSize: "24px", fontWeight: 700, children: A })
                ] }),
                /* @__PURE__ */ e.jsx(t, {})
              ]
            }
          )
        ]
      }
    )
  ] });
};
export {
  Ge as ReviewSubmission
};
